import "clsx";
import { F as FAQ, T as TrustPilotBanner } from "../../../../../chunks/TrustPilotBanner.js";
function _page($$payload) {
  FAQ($$payload);
  $$payload.out += `<!----> `;
  TrustPilotBanner($$payload);
  $$payload.out += `<!---->`;
}
export {
  _page as default
};
